export const AUTH_SERVER = window.HOSTS.AUTH[process.env.NODE_ENV];
export const IMG_RESOURCE = window.HOSTS.IMG_RESOURCE[process.env.NODE_ENV];
// export const AUTH_SERVER = 'http://192.168.0.226:8080'; // 测试
// export const AUTH_SERVER = 'http://192.168.0.107:8080'; //彭轩

/**
 * 单点登录相关
 */

export const SSO_SUBSYSTEM_REDIRECT = `${AUTH_SERVER}/sso/api/userInfo/subsystem`;

export const SSO_SUBSYSTEM_LIST = `${AUTH_SERVER}/sso/api/refurlMapInfo/navigationPage`;

export const RELOAD_PUBLIC_KEY = `${AUTH_SERVER}/sso/api/project/resetPublicKey`;

export const GET_USER_INFO = `${AUTH_SERVER}/sso/api/userInfo/getUserInfo`;

export const GET_USER_INFO_BY_ACCOUNT = `${AUTH_SERVER}/sso/api/userInfo/getUserInfoByAccount`;

/**
 * 项目列表
 */

export const ADD_PROJECT = `${AUTH_SERVER}/sso/api/project/insert`;

export const EDIT_PROJECT = `${AUTH_SERVER}/sso/api/project/update`;

export const REMOVE_PROJECT = `${AUTH_SERVER}/sso/api/project/del`;

export const REMOVE_APPLICATION = `${AUTH_SERVER}/sso/api/refurlMapInfo/del`;

export const ADD_APPLICATION = `${AUTH_SERVER}/sso/api/refurlMapInfo/insert`;

export const EDIT_APPLICATION = `${AUTH_SERVER}/sso/api/refurlMapInfo/update`;

export const GET_PROJECT_APPS = `${AUTH_SERVER}/sso/api/refurlMapInfo/navigationPage`;
export const GET_PICTURES = `${AUTH_SERVER}/sso/api/picture/list`;
export const UPLOAD_PICTURES = `${AUTH_SERVER}/sso/api/upload/uploadPicture`;
export const DEL_PICTURES = `${AUTH_SERVER}/sso/api/picture/del`;
export const GET_DETAILS = `${AUTH_SERVER}/sso/api/refurlMapInfo/getDetail`;
export const EDIT_DETAILS = `${AUTH_SERVER}/sso/api/refurlMapInfo/editDetail`;
export const GET_TAG_BY_ID = `${AUTH_SERVER}/sso/api/project/getTag`;
export const EDIT_TAG = `${AUTH_SERVER}/sso/api/project/updateTag`;

/**
 * 应用分组
 */
export const GET_ROLE_LIST = `${AUTH_SERVER}/sso/api/role/list`;
export const ADD_ROLE = `${AUTH_SERVER}/sso/api/role/insert`;
export const EDIT_ROLE = `${AUTH_SERVER}/sso/api/role/update`;
export const DELETE_ROLE = `${AUTH_SERVER}/sso/api/role/del`;
export const BIND_REFURL = `${AUTH_SERVER}/sso/api/roleRefurl/insert`;
export const UNBIND_REFURL = `${AUTH_SERVER}/sso/api/roleRefurl/update`;
export const GET_ALLAPP = `${AUTH_SERVER}/sso/api/project/findAllApp`;
export const GET_APP_BY_ID = `${AUTH_SERVER}/sso/api/roleRefurl/findByRoleIds`;
export const BATCH_BINDAPP = `${AUTH_SERVER}/sso/api/roleRefurl/batchBind`;

/**
 * 用户管理
 */
export const USER_LIST = `${AUTH_SERVER}/sso/api/userInfo/list`;
export const REMOVE_USER = `${AUTH_SERVER}/sso/api/userInfo/del`;
export const GET_USERISROLE = `${AUTH_SERVER}/sso/api/userRole/findAllRolesByAccount`;
export const EDIT_USERISROLE = `${AUTH_SERVER}/sso/api/userRole/assignRoles`;
export const GET_ACCOUNT = `${AUTH_SERVER}/sso/api/subsystemUser/findSubsystemInfo`;
export const BIND_ACCOUNT = `${AUTH_SERVER}/sso/api/subsystemUser/insert`;
export const EDIT_ACCOUNT = `${AUTH_SERVER}/sso/api/subsystemUser/update`;
export const REMOVE_ACCOUNT = `${AUTH_SERVER}/sso/api/subsystemUser/del`;
export const OPEN_USER = `${AUTH_SERVER}/sso/api/userInfo/enable`;
export const OFF_USER = `${AUTH_SERVER}/sso/api/userInfo/disable`;
export const OPEN_ADMIN = `${AUTH_SERVER}/sso/api/userInfo/openAdmin`;
export const OFF_ADMIN = `${AUTH_SERVER}/sso/api/userInfo/closeAdmin`;
export const DING_USER_SYNC = `${AUTH_SERVER}/sso/api/userInfo/syncDingTalkDeptUser`;
export const ADD_USER = `${AUTH_SERVER}/sso/api/userInfo/add`;

/**
 * 用户应用场景
 */
export const GET_ALLAPP_BY_USER = `${AUTH_SERVER}/sso/api/roleRefurl/allAppByUser`;
export const GET_TAG = `${AUTH_SERVER}/sso/api/tagClassify/list`;

/**
 * 白名单
 */
export const GET_WHITE_LIST = `${AUTH_SERVER}/sso/api/whiteListPhone/list`;
export const OPEN_WHITE_LIST = `${AUTH_SERVER}/sso/api/whiteListPhone/open`;
export const CLOSE_WHITE_LIST = `${AUTH_SERVER}/sso/api/whiteListPhone/close`;
export const GET_WHITE_LIST_STATE = `${AUTH_SERVER}/sso/api/whiteListPhone/status`;
export const ADD_WHITE_LIST_PHONE = `${AUTH_SERVER}/sso/api/whiteListPhone/insertList`;
export const REMOVE_WHITE_LIST_PHONE = `${AUTH_SERVER}/sso/api/whiteListPhone/del`;

/**
 * 注册登录
 */
export const SSO_LOGIN_PHONE = `${AUTH_SERVER}/sso/api/userInfo/phoneLogin`;
export const SSO_LOGIN = `${AUTH_SERVER}/sso/api/userInfo/login`;
export const SSO_REGISTER = `${AUTH_SERVER}/sso/api/userInfo/register`;
export const SSO_REGISTER_PHONE = `${AUTH_SERVER}/sso/api/userInfo/registerByPhone`;
export const SEND_MSG = `${AUTH_SERVER}/sso/api/userInfo/sendSms`;
export const SSO_LOGIN_DINGDING = `${AUTH_SERVER}/sso/api/userInfo/dingdingLogin`;
export const SSO_LOGIN_DING_CONTAINER = `${AUTH_SERVER}/sso/api/userInfo/loginAuthCode`;

/**
 * 标签管理
 */

export const ADD_TAG = `${AUTH_SERVER}/sso/api/tagClassify/insertList`;
export const REMOVE_TAG = `${AUTH_SERVER}/sso/api/tagClassify/del`;
export const EDIT_TAG_NAME = `${AUTH_SERVER}/sso/api/tagClassify/update`;
